const distanceXl = 24
const distancel = 16
const distancem = 10
const distances = 10
const cardWXl = 270
const cardWL = 210
const cardWM = 166
const cardWS = 145 //

const cardHXl = 385
const cardHL = 308
const cardHM = 264
const cardHS = 202

const cardWXS = 300

export const layoutSizes = {
    grid: {
        distance: {
            xl: distanceXl, //24
            l: distancel,   //16
            m: distancem,   //10
            s: distances,   //10
        },
    },
    elementWidth: {
        isHorizontal: {
            xl: cardWXl * 2 + distanceXl,   //564 = 270*2+24
            l: cardWL * 2 + distancel,      //446 = 220*2+16
            m: cardWM * 2 + distancem,      //380 = 187*2+6
            s: cardWS * 2 + distances,      //274 = 134*2+6
            xs: cardWXS,
        },
        nonHorizontal: {
            xl: cardWXl * 2 + distanceXl,   //564 = 270*2+24
            l: cardWL * 2 + distancel,      //446 = 220*2+16
            m: cardWM * 2 + distancem,      //380 = 187*2+6
            s: cardWS * 2 + distances,       //274 = 134*2+6 
            xs: cardWXS,
        },
    },
    elementHeight: {
        isHorizontal: {
            xl: cardHXl,    //385
            l: cardHL,      //308
            m: cardHM,      //264
            s: cardHS,      //188
        },
        nonHorizontal: {
            xl: cardHXl * 2 + distanceXl,   //794 = 385*2+24
            l: cardHL * 2 + distancel,     //622 = 308*2+16
            m: cardHM * 2 + distancem,      //534=264*2+6
            s: cardHS * 2 + distances,      //382=188*2+6
        },
    },
    museumHeight: {
        xl: cardHXl,    //385
        l: cardHL,      //308
        m: cardHM,      //264
        s: cardHS,      //188
    },
    museumWidth: {
        xl: cardWXl,    //272
        l: cardWL,      //220
        m: cardWM,      //187
        s: cardWS,      //134
    },
    museumPadding: {
        xl: 12,
        l: 8,
        m: 4,
        s: 4,
    },
    gameCardShort: {
        height: {
            xl: 302,
            l: 244,
            m: 215,
            s: 151,
        },

    },
    cardTitle: {
        size: {
            xl: 14,
            l: 14,
            m: 13,
            s: 13,
        },
        lineHeight: {
            xl: 17,
            l: 17,
            m: 17,
            s: 17,
        },
        wrapperHeight: {
            xl: 71,
            l: 55,
            m: 45,
            s: 45,
        }
    },
}const distanceXl = 24
const distancel = 16
const distancem = 10
const distances = 10
const cardWXl = 270
const cardWL = 210
const cardWM = 166
const cardWS = 145 //

const cardHXl = 385
const cardHL = 308
const cardHM = 264
const cardHS = 202

const cardWXS = 300

export const layoutSizes = {
    grid: {
        distance: {
            xl: distanceXl, //24
            l: distancel,   //16
            m: distancem,   //10
            s: distances,   //10
        },
    },
    elementWidth: {
        isHorizontal: {
            xl: cardWXl * 2 + distanceXl,   //564 = 270*2+24
            l: cardWL * 2 + distancel,      //446 = 220*2+16
            m: cardWM * 2 + distancem,      //380 = 187*2+6
            s: cardWS * 2 + distances,      //274 = 134*2+6
            xs: cardWXS,
        },
        nonHorizontal: {
            xl: cardWXl * 2 + distanceXl,   //564 = 270*2+24
            l: cardWL * 2 + distancel,      //446 = 220*2+16
            m: cardWM * 2 + distancem,      //380 = 187*2+6
            s: cardWS * 2 + distances,       //274 = 134*2+6 
            xs: cardWXS,
        },
    },
    elementHeight: {
        isHorizontal: {
            xl: cardHXl,    //385
            l: cardHL,      //308
            m: cardHM,      //264
            s: cardHS,      //188
        },
        nonHorizontal: {
            xl: cardHXl * 2 + distanceXl,   //794 = 385*2+24
            l: cardHL * 2 + distancel,     //622 = 308*2+16
            m: cardHM * 2 + distancem,      //534=264*2+6
            s: cardHS * 2 + distances,      //382=188*2+6
        },
    },
    museumHeight: {
        xl: cardHXl,    //385
        l: cardHL,      //308
        m: cardHM,      //264
        s: cardHS,      //188
    },
    museumWidth: {
        xl: cardWXl,    //272
        l: cardWL,      //220
        m: cardWM,      //187
        s: cardWS,      //134
    },
    museumPadding: {
        xl: 12,
        l: 8,
        m: 4,
        s: 4,
    },
    gameCardShort: {
        height: {
            xl: 302,
            l: 244,
            m: 215,
            s: 151,
        },

    },
    cardTitle: {
        size: {
            xl: 14,
            l: 14,
            m: 13,
            s: 13,
        },
        lineHeight: {
            xl: 17,
            l: 17,
            m: 17,
            s: 17,
        },
        wrapperHeight: {
            xl: 71,
            l: 55,
            m: 45,
            s: 45,
        }
    },
}